import {
    COMMODITY_LIST,
    COMMODITY_PAGINATION
} from './constant';
import { APICall } from '@/config/NetworkUtility';
import { setAuthToken } from '@/utility/CommonConstant';


/**
 * 
 * @param {*} payload 
 * @returns 
 */
export const getCommodityList = (payload) => {
    return dispatch => {
        const queryParams = new URLSearchParams({
            ...payload,
        }).toString();
        // const url = `v1/AddressBook/GetCompanyAddressList?${queryParams}`;
        const url = `v1/Commodity/GetCommodityList?${queryParams}`;
        return APICall('get', payload, url).then(result => {
            if (result?.statuscode === 200 || result?.statuscode === 201) {
                dispatch({
                    type: COMMODITY_LIST,
                    payload: result?.data || [],
                });
                dispatch({
                    type: COMMODITY_PAGINATION,
                    payload: result?.pagination || {},
                });
                return result?.data;
            } else {
                return Promise.reject();
            }
        }, error => {
            return Promise.reject(error);
        });
    };
};

/**
 * 
 * @param {*} payload 
 * @returns 
 */
export const createCommodity = (payload) => {
    const url = `v1/Commodity/CreateCommodity`;
    return APICall('post', payload, url).then(async result => {
        if (result?.statuscode === 201 || result?.statuscode === 200) {
            // const payList = { IPageNo: 1, IPageRecords: 10, FilterType: 'ALL', SearchKeyword: '' }
            // await getAddressBookList(payList);
            return result;
        } else {
            return false;
        }
    }, error => {
        return error;
    });
};

/**
 * 
 * @param {*} payload 
 * @returns 
 */
export const UpdateCommodity = (payload) => {
    const url = `v1/Commodity/UpdateCommodity`;
    return APICall('post', payload, url).then(async result => {
        if (result?.statuscode === 201 || result?.statuscode === 200) {
            const payList = { IPageNo: 1, IPageRecords: 10, FilterType: 'ALL', SearchKeyword: '' }
            // await getAddressBookList(payList);
            return result;
        } else {
            return false;
        }
    }, error => {
        return error;
    });
};

/**
 * 
 * @param {*} payload 
 * @returns 
 */
export const DeleteCommodity = (payload) => {
    const url = `v1/Commodity/DeleteCommodity`;
    return APICall('post', payload, url).then(async result => {
        if (result?.statuscode === 201 || result?.statuscode === 200) {
            const payList = { IPageNo: 1, IPageRecords: 10, FilterType: 'ALL', SearchKeyword: '' }
            // await getAddressBookList(payList);
            return result;
        } else {
            return false;
        }
    }, error => {
        return error;
    });
};

// /**
//  * 
//  * @param {*} payload 
//  * @returns 
//  */
// export const getBookingDetails = (payload) => {
//     return dispatch => {
//         const url = `v1/Booking/GetBookingByID?BookingId=${payload}`;
//         return APICall('get', payload, url).then(result => {
//             if (result?.statuscode === 200 || result?.statuscode === 201) {
//                 return result?.data;
//             } else {
//                 return Promise.reject();
//             }
//         }, error => {
//             return Promise.reject(error);
//         });
//     };
// };


